import { ROUTE_NAMES } from '@/lib/enums';
import { ROLE_ADMIN } from '@/util/roles';

export const routes = [
	{
		path: 'clients',
		name: ROUTE_NAMES.DEPOT.CLIENTS.OVERVIEW,
		component: () => {
			return import('@/views/depot/clients/All-Clients.vue');
		},
		meta: {
			requireAuth: true,
			breadcrumb: 'Clients',
			minRole: ROLE_ADMIN,
		},
	},
];
